import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useNavigate } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import _useTranslate from '../hooks/_useTranslate';

/*
 * App-wide toast. Same public API as before (show / mode / heading / message /
 * onClose) so all call sites are unchanged — internals unified onto MUI
 * Snackbar + Alert (themed severity colours, deterministic top-centre anchor,
 * slide-down transition, 7s auto-hide, accessible role="alert").
 * mode → severity:  stock|error → error (red);  cart|qrcode → success (green);
 * favorite/default → success with a heart icon (positive confirmation).
 */

const SlideUp = (props) => <Slide {...props} direction="up" />;

const SmallAlert = ({ show, mode, heading, onClose, message, feathersStore }) => {

  const navigate = useNavigate();
  const common = _useTranslate(feathersStore.language, "common");

  const severity =
    (mode === "stock" || mode === "error") ? "error" :
    "success"; // cart / qrcode / favorite / default

  const goToCart = () => { onClose && onClose(); navigate('/cart'); };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return; // match original: dismiss only on timeout / close button
    onClose && onClose();
  };

  return (
    <Snackbar
      open={!!show}
      autoHideDuration={7000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      TransitionComponent={SlideUp}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={onClose}
        icon={mode === 'favorite' ? <FavoriteBorderIcon fontSize="inherit" /> : undefined}
        action={mode === 'cart' ? (
          <>
            <Button color="inherit" size="small" onClick={goToCart} sx={{ fontWeight: 700 }}>
              {common.show}
            </Button>
            <IconButton size="small" color="inherit" aria-label="Close" onClick={onClose}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        ) : undefined}
        sx={{ width: '100%', maxWidth: 440, alignItems: 'center', boxShadow: 'var(--shadow-3, 0 8px 24px rgba(0,0,0,0.14))' }}
      >
        {heading && <AlertTitle sx={{ mb: 0.25, fontWeight: 700 }}>{heading}</AlertTitle>}
        {message}
      </Alert>
    </Snackbar>
  );
};

export default inject('feathersStore')(observer(SmallAlert));
